import "datatables.net-bs4";
import "datatables.net-bs4/css/dataTables.bootstrap4.min.css";
import "datatables.net-buttons-bs4";
import "datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css";
import "datatables.net-buttons/js/buttons.html5.min.js";
import "datatables.net-buttons/js/buttons.print.min.js";
import "datatables.net-responsive-bs4";
import "datatables.net-responsive-bs4/css/responsive.bootstrap4.min.css";
import $ from "jquery";
import "jszip";
import "pdfmake/build/pdfmake";
import "pdfmake/build/vfs_fonts";
import { useEffect, useRef } from "react";
import { formatoMoneda } from "../../../../configuracion/validaciones";
import moment from "moment";
import { ImprimirCierre } from '../imprimir/ImprimirCierre';
import { useContextUsuario } from "../../../../contexto/usuario/UsuarioContext";
import { createRoot } from "react-dom/client";
import ReporteCierre from "../imprimir/ReporteCierre";
import { pdf } from '@react-pdf/renderer';
import Swal from 'sweetalert2';
import { mostraAlertaError } from "../../../../componentes/alerts/sweetAlert"

const TablaCierre = ({ datos }) => {
    const { usuario } = useContextUsuario();
    const tableRef = useRef();

    const handleImprimirReporteCierres = async (cierre) => {
        Swal.fire({
            title: 'Generando PDF...',
            text: 'Por favor, espere un momento.',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        if (cierre) {
            try {
                const blob = await pdf(<ReporteCierre data={cierre} usuario={usuario} />).toBlob();
                const url = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = `ReporteCierre_${cierre.id}.pdf`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(url);
                Swal.close();
            } catch (error) {
                Swal.close();
                mostraAlertaError("Error al generar el PDF. Inténtelo de nuevo.");
            }
        } else {
            Swal.close();
            mostraAlertaError("No se encontraron detalles para generar el reporte.", "Error");
        }
    };

    // Función para manejar la impresión
    const handleImprimirCierre = (cierre) => {
        ImprimirCierre(cierre, usuario);
    };
    
    useEffect(() => {
        // Destruir la instancia anterior de DataTables si existe
        if ($.fn.DataTable.isDataTable(tableRef.current)) {
            $(tableRef.current).DataTable().destroy();
        }

        $(tableRef.current).DataTable({
            data: datos,
            columns: [
                {
                    title: "ID",
                    data: "id"
                },
                {
                    title: "Usuario",
                    data: "Usuario.nombre"
                },
                {
                    title: "Empleado",
                    data: "Usuario.Empleados",
                    render: (empleados) => {
                        const empleado = empleados?.[0];
                        return empleado?.nombreCorto || "Sin empleado";
                    }
                },
                {
                    title: "Caja",
                    data: "caja.nombre"
                },
                {
                    title: "Pagos Realizados",
                    data: null,
                    render: (data, type, row) => {
                        const efectivo = row.efectivo !== undefined ? row.efectivo : 0;
                        const pos = row.pos !== undefined ? row.pos : 0;
                        const transferencias = row.transferencias !== undefined ? row.transferencias : 0;

                        let pagosHtml = '';

                        if (efectivo > 0) {
                            pagosHtml += `<div><strong>Efectivo:</strong> L. ${efectivo.toFixed(2)}</div>`;
                        }
                        if (pos > 0) {
                            pagosHtml += `<div><strong>POS:</strong> L. ${pos.toFixed(2)}</div>`;
                        }
                        if (transferencias > 0) {
                            pagosHtml += `<div><strong>Transferencias:</strong> L. ${transferencias.toFixed(2)}</div>`;
                        }

                        if (pagosHtml === '') {
                            return 'N/A';
                        }

                        return pagosHtml;
                    }
                },
                {
                    title: "Efectivo Sistema",
                    data: "efectivosistema",
                    render: (data) => {
                        const valorFormateado = formatoMoneda(data);
                        return `<span style="text-align: right; display: block;">${valorFormateado}</span>`;
                    }
                },
                {
                    title: "Fecha Cierre",
                    data: "createdAt",
                    render: (fecha) => {
                        const f = moment(fecha);
                        return f.isValid() ? f.format("DD/MM/YYYY") : "N/A";
                    }
                },
                {
                    title: "Acciones",
                    data: null,
                    orderable: false,
                    searchable: false,
                    className: "dt-center all",
                    exportable: false, // Mantenemos esta para CSV/Excel/PDF
                    createdCell: (td, cellData, rowData, row, col) => {
                        const root = createRoot(td);
                        root.render(
                            <>
                                <button
                                    className="btn btn-outline-info"
                                    onClick={() => handleImprimirCierre(rowData)}
                                    title="Imprimir Cierre"
                                >
                                    <i className="fas fa-print"></i>
                                </button>
                                <button
                                    className="btn btn-outline-success mx-2"
                                    onClick={() => handleImprimirReporteCierres(rowData)}
                                    title="Imprimir Reporte Cierre"
                                >
                                    <i className="fas fa-chart-bar"></i>
                                </button>
                            </>
                        );
                    },
                },
            ],
            paging: true,
            lengthChange: true,
            pageLength: 10,
            searching: true,
            ordering: true,
            info: true,
            autoWidth: true,
            buttons: [
                'copy',
                'csv',
                'excel',
                'pdf',
                {
                    extend: 'print',
                    exportOptions: {
                        columns: ':not(:nth-child(7))'
                    }
                }
            ],
            dom:
                "<'row mb-3'<'col-sm-12 col-md-6 text-left'B><'col-sm-12 col-md-6 text-right'f>>" +
                "<'row'<'col-sm-12'tr>>" +
                "<'row mt-3'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7'p>>",
            responsive: true,
            language: {
                decimal: "",
                emptyTable: "No hay información",
                info: "Mostrando _START_ a _END_ de _TOTAL_ Entradas",
                infoEmpty: "Mostrando 0 to 0 of 0 Entradas",
                infoFiltered: "(Filtrado de _MAX_ total entradas)",
                infoPostFix: "",
                thousands: ",",
                lengthMenu: "Mostrar _MENU_ Entradas",
                loadingRecords: "Cargando...",
                processing: "Procesando...",
                zeroRecords: "Sin resultados encontrados",
                search: "Buscar",
                paginate: {
                    first: "|<<",
                    last: ">>|",
                    next: ">>",
                    previous: "<<",
                },
            },
            destroy: true,
        });
        //}
    }, [datos, usuario]);

    return (
        <div className="table-responsive">
            <table
                ref={tableRef}
                id="clientes"
                className="table table-bordered table-hover"
            ></table>
        </div>
    );
};

export default TablaCierre;